import { render, staticRenderFns } from "./ProcessingDaysAndHolidays.vue?vue&type=template&id=20315912"
import script from "./ProcessingDaysAndHolidays.vue?vue&type=script&lang=ts"
export * from "./ProcessingDaysAndHolidays.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports